<template>
  <svg
    width="48px"
    height="48px"
    viewBox="0 0 48 48"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g id="T_1300-x-600-Copy" transform="translate(-396.000000, -417.000000)">
        <g id="Group-3" transform="translate(396.000000, 417.000000)">
          <rect id="Rectangle" stroke="#817A81" x="0.5" y="0.5" width="47" height="47" rx="23.5"></rect>
          <polygon
            id="Fill"
            fill="#817A81"
            transform="translate(24.000000, 24.000000) rotate(90.000000) translate(-24.000000, -24.000000) "
            points="25.3 19.7 29.1 23.5 17 23.5 17 24.5 29.1 24.5 25.3 28.3 26 29 31 24 26 19"
          ></polygon>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'Scroll'
};
</script>
